import { ErrorLog } from '@/app/models/interface/error-log.model';
import { environment } from '@/environments/environment';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, map } from 'rxjs';
import { handleError } from '../tools/handle-error.tools';
import { CookieService } from 'ngx-cookie-service';
import { TOKEN } from '../keys/key';
import { CustomResponse } from '@/app/models/interface/response.model';

@Injectable({ providedIn: 'root' })
export class ErrorLogService {
  private readonly http = inject(HttpClient);
  private readonly url = environment.api + 'error-log';
  private readonly cookieService = inject(CookieService);

  /**
   * @description Método para creación de errores lógicos
   */
  create(data: Partial<ErrorLog>) {
    const token = this.cookieService.get(TOKEN) ?? '';

    return this.http
      .post<CustomResponse<ErrorLog>>(this.url, data, {
        headers: { authorization: `Bearer ${token}` },
      })
      .pipe(
        catchError((err) => handleError(err)),
        map((data) => data.result),
      );
  }
}
